import styled, { css } from 'styled-components';

import {
  mediaNavCollapsed,
  mediaTopBarHidden,
  mediaTopBarVisible,
} from '@xing-com/layout-tokens';
import { Link } from '@xing-com/link';
import {
  cornerRadiusM,
  cornerRadiusXL,
  scale010,
  scale040,
  scale060,
  scale110,
  spaceS,
  xdlColorFocusRing,
  xdlColorHoverSecondary,
  xdlColorText,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const StyledHeadline = styled(Headline)`
  padding-top: ${scale040};
`;

export const ProductsWrapper = styled.div`
  position: relative;
  padding-bottom: ${scale110};
  top: ${scale060};
`;

type StyledTitleProps = {
  $hideTitleOnSmallerScreens: boolean;
};

export const StyledTitle = styled.p<StyledTitleProps>`
  margin: 0;
  text-decoration: none;
  text-align: left;
  white-space: nowrap;

  @media ${mediaTopBarVisible} {
    display: none;
  }

  @media ${mediaTopBarHidden} {
    display: ${({ $hideTitleOnSmallerScreens }) =>
      $hideTitleOnSmallerScreens ? 'none' : 'block'};
  }
`;

export const StyledLink = styled(Link)<{
  $isActive: boolean;
}>`
  color: ${xdlColorText};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border-radius: ${cornerRadiusXL};
  padding: ${spaceS};

  @media ${mediaNavCollapsed} {
    border-radius: ${cornerRadiusM};
    margin-bottom: 0;
  }

  &:hover,
  &:active {
    text-decoration: none;
    background-color: ${xdlColorHoverSecondary};

    @media (prefers-contrast: more) {
      outline: ${scale010} solid ${xdlColorFocusRing};
    }
  }

  &:focus {
    text-decoration: none;
    outline: ${scale010} solid ${xdlColorFocusRing};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: bold;
    `};
`;
